import axios from 'axios'

class Recording {
  static async get(instanceId) {
    const googleTokenId = window.localStorage.getItem('googleTokenId')

    const res = await axios.get('recordings', {
      params: {
        instanceId,
        googleTokenId,
      },
    })

    return res.data
  }

  static async reupload(meetingId) {
    const res = await axios.get('recording/reupload', {
      params: {
        meetingId,
      },
    })

    return res.data
  }
}

export default Recording
